import OptionVideo from './OptionVideo'

export * from './OptionVideo'

export default OptionVideo
